// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { StyleAttributor, Scope } = Quill.import('parchment');

class OverprintsAttributor extends StyleAttributor {
    public converter: (value: any) => string = (value) => value;

    public add(node: HTMLElement, value: any) {
        if (!super.canAdd(node, value)) {
            return false;
        }

        // preserve original overprints array
        // eslint-disable-next-line no-param-reassign
        node.dataset.overprints = JSON.stringify(value);

        // If the color isn't set, we want to use the color of the top overprint
        if (value && value.length !== 0) {
            const converted = this.converter(value[value.length - 1]);
            node.style.setProperty('--ql-overprint-color', converted);
            return true;
        }

        return false;
    }

    // eslint-disable-next-line class-methods-use-this
    public remove(node: HTMLElement): void {
        node.style.removeProperty('--ql-overprint-color');
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    }

    // get source color value embedded on element
    // eslint-disable-next-line class-methods-use-this
    public value(node: HTMLElement): any {
        return JSON.parse(node.dataset.overprints!);
    }
}

// @ts-ignore
export default new OverprintsAttributor('overprints', '--ql-overprint-color', { scope: Scope.INLINE });
// @ts-ignore
export const BlockOverprintsAttributor = new OverprintsAttributor('blockOverprints', '--ql-overprint-color', { scope: Scope.BLOCK });
